(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ninja-cart-boost"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ninja-cart-boost')) {
    customElements.define('ninja-cart-boost', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.reconciling = false;
        this.reconcileAgain = false;
        this.checkoutPending = false;
        this.giftChangePending = false;

        this.addEventListener('click', this.handleBoostClick);
        document.addEventListener('click', this.handleCartClick, true);
        document.addEventListener('change', this.handleCartChange, true);
        document.addEventListener('cart:refresh', this.handleCartRefresh);
        window.addEventListener('pageshow', this.handlePageShow);

        this.resetQuickControls();
        this.renderState();
        if (performance.now() >= (window.__ncbFreshSectionUntil || 0)) {
          this.scheduleReconcile(80);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.reconcileTimer);
        this.removeEventListener('click', this.handleBoostClick);
        document.removeEventListener('click', this.handleCartClick, true);
        document.removeEventListener('change', this.handleCartChange, true);
        document.removeEventListener('cart:refresh', this.handleCartRefresh);
        window.removeEventListener('pageshow', this.handlePageShow);
      }

      handleBoostClick = (event) => {
        const choice = event.target.closest('[data-ncb-add]');
        const remove = event.target.closest('[data-ncb-remove]');
        const quick = event.target.closest('[data-ncb-quick]');

        if (choice) this.chooseGift(choice);
        if (remove) this.removeGift();
        if (quick) this.quickAdd(quick);
      };

      handleCartClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const owner = target.closest('cart-items-component');
        if (!owner || !owner.contains(this)) return;

        const checkout = target.closest('[name="checkout"]');
        if (checkout && !window.__ncbCheckoutApproved) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.prepareCheckout();
          return;
        }

        const quantityAction = target.closest('[name="plus"], [name="minus"], .cart-items__remove');
        if (quantityAction && this.interceptInvalidGiftChange(event, quantityAction)) return;

        if (quantityAction) {
          this.scheduleReconcile(900);
        }
      };

      handleCartChange = (event) => {
        const input = event.target instanceof Element
          ? event.target.closest('input[name="updates[]"]')
          : null;
        if (!input) return;
        const owner = input.closest('cart-items-component');
        if (!owner || !owner.contains(this)) return;
        this.interceptInvalidGiftChange(event, input);
      };

      interceptInvalidGiftChange(event, control) {
        if (!this.dataset.giftKey) return false;
        const row = control.closest('[data-key]');
        const input = row?.querySelector('input[name="updates[]"]');
        const key = row?.dataset.key;
        if (!key || !input) return false;

        const currentQuantity = Number(input.dataset.cartQuantity || input.value || 0);
        let nextQuantity = Number(input.value || currentQuantity);
        if (control.matches('.cart-items__remove')) nextQuantity = 0;
        if (control.matches('[name="minus"]')) nextQuantity = Math.max(0, currentQuantity - 1);
        if (control.matches('[name="plus"]')) nextQuantity = currentQuantity + 1;

        const paidAfterChange = Number(this.dataset.paidCount || 0) - currentQuantity + nextQuantity;
        if (paidAfterChange >= 3) return false;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.updatePaidLineAndRemoveGift(key, nextQuantity);
        return true;
      }

      async updatePaidLineAndRemoveGift(key, quantity) {
        if (this.giftChangePending) return;
        this.giftChangePending = true;
        this.setBusy(true);
        try {
          const data = await this.cartMutation('cart/update.js', {
            updates: {
              [key]: quantity,
              [this.dataset.giftKey]: 0
            },
            attributes: { _ncb_gift_dismissed: null }
          });
          if (this.isConnected) this.replaceSection(data);
        } catch (error) {
          console.warn('Paid item and gift update failed.', error);
          this.scheduleReconcile(100);
        } finally {
          this.giftChangePending = false;
          this.setBusy(false);
        }
      }

      handleCartRefresh = () => this.scheduleReconcile(120);
      handlePageShow = () => this.scheduleReconcile(120);

      scheduleReconcile(delay = 150) {
        clearTimeout(this.reconcileTimer);
        this.reconcileTimer = setTimeout(() => this.reconcile(), delay);
      }

      resetQuickControls() {
        this.querySelectorAll('[data-ncb-quick]').forEach((button) => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (button.textContent.trim() === 'ADDING…') button.textContent = '+ QUICK ADD';
        });
      }

      async reconcile() {
        if (this.reconciling) {
          this.reconcileAgain = true;
          return;
        }

        this.reconciling = true;
        try {
          do {
            this.reconcileAgain = false;
            await this.reconcileOnce();
          } while (this.reconcileAgain && this.isConnected);
        } catch (error) {
          console.warn('Ninja cart reconciliation failed.', error);
        } finally {
          this.reconciling = false;
        }
      }

      async reconcileOnce() {
        const cart = await this.fetchCart();
        if (!this.isConnected) return;

        const state = this.cartState(cart);
        this.updateLiveState(state);

        if (state.paidCount < 3) {
          if (state.gifts.length || state.giftDismissed) {
            await this.updateGiftLines(state.gifts, null, true);
          }
          return;
        }

        if (state.gifts.length) {
          const keeper = state.gifts[0];
          const needsNormalization =
            state.gifts.length > 1 ||
            Number(keeper.quantity) !== 1;

          if (needsNormalization) {
            await this.updateGiftLines(state.gifts, keeper.key);
          }
          return;
        }

        const flexAlreadyPaid = state.paidProductIds.has(String(this.dataset.flexProduct || ''));
        const automaticGift = flexAlreadyPaid
          ? this.dataset.fallbackGiftVariant
          : this.dataset.flexVariant;
        if (!state.giftDismissed && automaticGift) {
          await this.addVariant(automaticGift, true);
        }
      }

      cartState(cart) {
        const gifts = [];
        const paidProductIds = new Set();
        let paidCount = 0;

        for (const item of cart.items || []) {
          if (item.properties?._ninja_free_gift === 'true') {
            gifts.push(item);
          } else {
            paidCount += Number(item.quantity || 0);
            paidProductIds.add(String(item.product_id || ''));
          }
        }

        return {
          paidCount,
          gifts,
          itemCount: Number(cart.item_count || 0),
          giftDismissed: cart.attributes?._ncb_gift_dismissed === 'true',
          paidProductIds
        };
      }

      updateLiveState(state) {
        this.dataset.paidCount = String(state.paidCount);
        this.dataset.giftKey = state.gifts[0]?.key || '';
        this.dataset.giftVariant = String(state.gifts[0]?.variant_id || '');
        this.dataset.flexPaid = String(
          state.paidProductIds.has(String(this.dataset.flexProduct || ''))
        );
        this.renderState();
        this.updateHeaderCount(state.itemCount);
      }

      renderState() {
        const paidCount = Number(this.dataset.paidCount || 0);
        const hasGift = Boolean(this.dataset.giftKey);
        const gifts = this.querySelector('[data-ncb-gifts]');
        const quick = this.querySelector('[data-ncb-quick-list]');
        const quickHeading = quick?.querySelector('.ncb__gift-head strong');

        if (gifts) gifts.hidden = paidCount < 3;
        if (quick) quick.hidden = false;
        if (quickHeading) {
          quickHeading.textContent = paidCount === 1
            ? 'ADD ONE FOR FREE SHIPPING'
            : paidCount === 2
              ? 'ADD ONE TO UNLOCK YOUR GIFT'
              : 'ADD MORE TO YOUR ORDER';
        }

        this.querySelectorAll('[data-ncb-add]').forEach((button) => {
          const selected = String(button.dataset.ncbAdd) === String(this.dataset.giftVariant);
          button.classList.toggle('is-selected', selected);
          const label = button.querySelector('i');
          if (label) label.textContent = selected ? 'SELECTED ✓' : '+ CHOOSE';
        });
      }

      async updateGiftLines(gifts, keepKey, clearDismissed = false) {
        const updates = {};
        for (const gift of gifts) {
          updates[gift.key] = gift.key === keepKey ? 1 : 0;
        }

        const body = { updates };
        if (clearDismissed) {
          body.attributes = { _ncb_gift_dismissed: null };
        }

        const data = await this.cartMutation('cart/update.js', body);
        if (!this.isConnected) return;
        this.replaceSection(data);
      }

      async quickAdd(button) {
        if (button.disabled) return;

        const originalLabel = button.textContent;
        button.textContent = 'ADDING…';
        button.setAttribute('aria-busy', 'true');
        this.setBusy(true);

        try {
          const items = [{
            id: Number(button.dataset.ncbQuick),
            quantity: 1
          }];

          const unlocksGift = Number(this.dataset.paidCount || 0) === 2;
          const selectedProduct = String(button.dataset.ncbQuickProduct || '');
          const flexProduct = String(this.dataset.flexProduct || '');
          const flexWillBePaid = this.dataset.flexPaid === 'true' || selectedProduct === flexProduct;
          const automaticGift = flexWillBePaid
            ? this.dataset.fallbackGiftVariant
            : this.dataset.flexVariant;

          if (
            unlocksGift &&
            automaticGift
          ) {
            items.push({
              id: Number(automaticGift),
              quantity: 1,
              properties: { _ninja_free_gift: 'true' }
            });
          }

          const data = await this.cartMutation('cart/add.js', { items }, 'ninja-cart-fast');
          if (this.isConnected) this.replaceSection(data, 'ninja-cart-fast');
        } catch (error) {
          button.textContent = originalLabel;
          button.removeAttribute('aria-busy');
          console.warn('Quick add failed.', error);
        } finally {
          this.setBusy(false);
        }
      }

      async chooseGift(button) {
        const requestedVariant = String(button.dataset.ncbAdd || '');
        if (!requestedVariant || requestedVariant === String(this.dataset.giftVariant)) return;

        this.setBusy(true);

        try {
          const cart = await this.fetchCart();
          const state = this.cartState(cart);
          if (state.paidCount < 3) {
            if (state.gifts.length) await this.updateGiftLines(state.gifts, null);
            return;
          }

          if (state.gifts.length) {
            const updates = {};
            state.gifts.forEach((gift) => { updates[gift.key] = 0; });
            await this.cartMutation('cart/update.js', { updates });
          }

          await this.addVariant(requestedVariant, true);
        } catch (error) {
          console.warn('Gift change failed.', error);
        } finally {
          this.setBusy(false);
        }
      }

      async removeGift() {
        this.setBusy(true);

        try {
          const cart = await this.fetchCart();
          const state = this.cartState(cart);
          const updates = {};
          state.gifts.forEach((gift) => { updates[gift.key] = 0; });
          const data = await this.cartMutation('cart/update.js', {
            updates,
            attributes: { _ncb_gift_dismissed: 'true' }
          });
          if (this.isConnected) this.replaceSection(data);
        } catch (error) {
          console.warn('Gift removal failed.', error);
        } finally {
          this.setBusy(false);
        }
      }

      async prepareCheckout() {
        if (this.checkoutPending) return;
        this.checkoutPending = true;
        this.setCheckoutBusy(true);

        try {
          let cart = await this.fetchCart();
          let state = this.cartState(cart);

          if (state.paidCount < 3 && state.gifts.length) {
            const updates = {};
            state.gifts.forEach((gift) => { updates[gift.key] = 0; });
            await this.cartMutation('cart/update.js', { updates });
          } else if (
            state.paidCount >= 3 &&
            (state.gifts.length > 1 || Number(state.gifts[0]?.quantity || 0) !== 1)
          ) {
            const updates = {};
            state.gifts.forEach((gift, index) => { updates[gift.key] = index === 0 ? 1 : 0; });
            await this.cartMutation('cart/update.js', { updates });
          } else if (
            state.paidCount >= 3 &&
            !state.gifts.length &&
            !state.giftDismissed &&
            (this.dataset.flexVariant || this.dataset.fallbackGiftVariant)
          ) {
            const automaticGift = state.paidProductIds.has(String(this.dataset.flexProduct || ''))
              ? this.dataset.fallbackGiftVariant
              : this.dataset.flexVariant;
            if (automaticGift) await this.addVariant(automaticGift, true, false);
          }

          cart = await this.fetchCart();
          state = this.cartState(cart);

          if (state.paidCount < 3 && state.gifts.length) {
            throw new Error('Ineligible gift remains in cart');
          }

          window.__ncbCheckoutApproved = true;
          const checkout = document.querySelector('cart-items-component [name="checkout"]');
          checkout?.click();
          setTimeout(() => { window.__ncbCheckoutApproved = false; }, 1500);
        } catch (error) {
          console.warn('Cart could not be prepared for checkout.', error);
          this.scheduleReconcile(100);
        } finally {
          this.checkoutPending = false;
          this.setCheckoutBusy(false);
        }
      }

      setBusy(busy) {
        this.querySelectorAll('button').forEach((button) => { button.disabled = busy; });
      }

      setCheckoutBusy(busy) {
        const owner = this.closest('cart-items-component');
        owner?.querySelectorAll('[name="checkout"]').forEach((button) => {
          button.disabled = busy;
          button.setAttribute('aria-busy', String(busy));
        });
      }

      root() {
        return window.Shopify?.routes?.root || '/';
      }

      requestBody(extra, sectionId = this.dataset.sectionId) {
        return {
          ...extra,
          sections: sectionId,
          sections_url: window.location.pathname
        };
      }

      async fetchCart() {
        const response = await fetch(this.root() + 'cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }

      async cartMutation(endpoint, body, sectionId = this.dataset.sectionId) {
        const response = await fetch(this.root() + endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(this.requestBody(body, sectionId))
        });
        if (!response.ok) throw new Error('Cart mutation failed');
        return response.json();
      }

      async addVariant(id, isGift = true, render = true) {
        if (!id) return;
        const item = { id: Number(id), quantity: 1 };
        if (isGift) item.properties = { _ninja_free_gift: 'true' };

        const data = await this.cartMutation('cart/add.js', { items: [item] });
        if (render && this.isConnected) this.replaceSection(data);
      }

      updateHeaderCount(count) {
        document
          .querySelectorAll('[ref="cartBubbleCount"], [data-testid="cart-bubble"], [data-cart-count], .theme-drawer__badge')
          .forEach((element) => {
            element.textContent = String(count);
          });
      }

      replaceSection(data, responseSectionId = this.dataset.sectionId) {
        const sectionId = this.dataset.sectionId;
        const html = data.sections?.[responseSectionId];
        const current = document.getElementById('shopify-section-' + sectionId);
        if (!html || !current) {
          window.location.reload();
          return;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next =
          doc.getElementById('shopify-section-' + responseSectionId) ||
          doc.getElementById('shopify-section-cart-drawer-section');

        if (!next) {
          window.location.reload();
          return;
        }

        const previousScroll = current.querySelector('[data-cart-drawer-scroll]')?.scrollTop || 0;
        const currentCart = current.querySelector('cart-items-component');
        const nextCart = next.querySelector('cart-items-component');
        const currentQuick = current.querySelector('[data-ncb-quick-list]');
        const nextQuick = next.querySelector('[data-ncb-quick-list]');
        const nextBoost = next.querySelector('ninja-cart-boost');

        if (currentQuick && nextQuick) {
          nextQuick.replaceWith(currentQuick);
        } else if (currentQuick && nextBoost) {
          const trust = nextBoost.querySelector('.ncb__trust');
          if (trust) trust.before(currentQuick);
          else nextBoost.append(currentQuick);
        }

        window.__ncbFreshSectionUntil = performance.now() + 1000;
        if (currentCart && nextCart) {
          currentCart.replaceWith(nextCart);
        } else {
          current.replaceWith(next);
        }
        const renderedCount = Number(
          next.querySelector('[data-ncb-rendered-count], .theme-drawer__badge')?.textContent?.trim()
        );
        if (Number.isFinite(renderedCount)) this.updateHeaderCount(renderedCount);

        const activeSection = document.getElementById('shopify-section-' + sectionId) || next;
        const nextScroll = activeSection.querySelector('[data-cart-drawer-scroll]');
        if (nextScroll) {
          requestAnimationFrame(() => {
            nextScroll.scrollTop = Math.min(
              previousScroll,
              Math.max(0, nextScroll.scrollHeight - nextScroll.clientHeight)
            );
          });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ninja-hesitation-popup"] && !Shopify.designMode) return;
  try {
    if (!window.ncbPopupReady) {
    window.ncbPopupReady = true;
    const key='ncbPopupSeenAt';
    const show=async () => {
      const popup=document.querySelector('[data-ncb-popup]');
      if (!popup || popup.open) return;
      if (Date.now()-Number(localStorage.getItem(key)||0) < 604800000) return;
      const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json());
      if (cart.item_count > 0) return;
      localStorage.setItem(key,String(Date.now()));
      popup.showModal();
    };
    setTimeout(show,55000);
    document.addEventListener('mouseout',e=>{ if(e.clientY<=0) show(); },{once:true});
    document.addEventListener('click',e=>{ if(e.target.closest('[data-ncb-close]')) e.target.closest('dialog').close(); });
  }
  } catch(e) { console.error(e); }
})();

})();
